import { setOffer, getOffer, setOffers, getOffers } from './store'
import { buildWatchError } from '@/common/watch-error'
import { isEmpty } from '@/common/utils'
import store, { forceClearNavigationLock } from '../store'
import { SHOULD_HIDE_SWITCH_OFFER } from '@/common/constants'
import { ErrCustom } from '../error/custom-error'

class ErrNoOffer extends ErrCustom { }

const setOfferMixin = {
  data: () => ({
    offerId: null
  }),
  methods: {
    async setOffer (id) {
      await setOffer(id)
      this.offerId = id
    }
  }
}

const loadOffersMixin = {
  data: () => ({
    offers: [],
    isOffersLoading: true,
    offersError: false
  }),
  methods: {
    async loadOffers () {
      this.isOffersLoading = true
      try {
        let offers = await getOffers()
        if (!offers?.length) {
          offers = await this.$offerService.listOffers()
          await setOffers(offers)
        }
        this.offers = offers
      } catch (err) {
        this.$tracker.error(err)
        this.offersError = err.message
      }
      this.$nextTick(() => {
        this.isOffersLoading = false
      })
    }
  },
  async mounted () {
    await this.loadOffers()
  }
}

const singleOfferMixin = {
  data: () => ({
    isOfferLoading: true,
    offerError: false,
    offerId: '',
    offer: {},
    allowChangeOffer: false
  }),
  watch: {
    offerError: buildWatchError('onOfferError')
  },
  methods: {
    /**
     * @returns {Promise}
     */
    async loadOffer () {
      this.isOfferLoading = true

      try {
        let offers = await getOffers()
        if (!offers?.length) {
          offers = await this.$offerService.listOffers()
          await setOffers(offers)
        }
        const offer = offers?.find(el => el.id === this.offerId)
        if (!offer) {
          throw new ErrNoOffer('Plano não localizado')
        }
        this.offer = offer
      } catch (err) {
        forceClearNavigationLock()
        this.$tracker.error(err)
        this.offerError = err.message
      }
      this.$nextTick(() => {
        this.isOfferLoading = false
      })
    },
    async loadMeta () {
      let offers = await getOffers()
      if (!offers?.length) {
        offers = await this.$offerService.listOffers()
        await setOffers(offers)
      }
      const televendas = Buffer.from('' + this.$route.params.televendasdata, 'base64').toString('utf8').split(';')
      this.allowChangeOffer = (offers || []).length > 1 &&
        !(televendas.length === 3 || televendas.length === 4) &&
        !store.get(SHOULD_HIDE_SWITCH_OFFER)
    }
  },
  async mounted () {
    const { query } = this.$route

    if (query.offer_id) {
      await setOffer(query.offer_id)
      this.offerId = query.offer_id
    }

    if (isEmpty(this.offerId)) {
      this.offerId = await getOffer()
    }

    await this.$nextTick(async () => {
      await this.loadOffer()
      await this.loadMeta()
    })
  }
}

export { setOfferMixin, singleOfferMixin, loadOffersMixin }
